export default "__VITE_ASSET__CLPCtTbc__"